export default __webpack_public_path__ + "static/media/guide-img-1.e55fb2f0.png";